import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@mui/material';
import BaseField from './BaseField';

/**
 * EmailField component for workflow forms.
 * Extends the BaseField with email input functionality and validation.
 */
const EmailField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
  className,
  inputProps,
  ...rest
}) => {
  return (
    <BaseField
      id={id}
      name={name}
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
    >
      <MuiTextField
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        error={Boolean(error)}
        type="email"
        size="small"
        inputProps={{
          pattern: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
          ...inputProps,
        }}
        {...rest}
      />
    </BaseField>
  );
};

EmailField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};

EmailField.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: true,
  value: '',
  placeholder: 'example@domain.com',
};

export default EmailField;
